import React from "react";
import { Router } from "react-router-dom";
import history from "./../services/history";
import CustomRoutes from "./../routes";
// import {ConnectedRouter} from "react-router-redux";
import { Provider } from "react-redux";
import configureStore from "../redux/store/index";
// import { createTheme, ThemeProvider } from '@mui/material';
import "../static/css/wms.css"

import { createTheme, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import theme from "../static/styles/theme";
// import store from '../redux/store';

export const store = configureStore();

const appFont = createTheme({
	typography: {
		fontFamily: ["Nunito", "serif"].join(","),
	},
	zIndex: {
		modal: 1305, // Ensure the modal is above the tooltip
		// tooltip: 1300,
	},
	palette: {
		primary: {
		  main: "#F77200",
		  darker: '#053e85',
		},
		// neutral: {
		//   main: '#64748B',
		//   contrastText: '#fff',
		// },
		dark: {
			main: '#000000',
			contrastText: '#fff',
		},
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				html: {
					"*::-webkit-scrollbar": {
						width: "3px",
						height: "6px",
					},
					"*::-webkit-scrollbar-track": {
						background: "inherit",
						boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
					},
					"*::-webkit-scrollbar-thumb": {
						backgroundColor: theme.themeGray,
						borderRadius: "20px",
						border: theme.themeGray,
					},
					"*::-webkit-scrollbar-thumb:horizontal": {
						backgroundColor: "#827878",
						borderRadius: "20px",
						border: theme.themeGray,
					},
					"*::-webkit-scrollbar-corner": {
						background: "inherit",
					},
				},
			},
		},
		// Global Button customizations
		MuiButton: {
			defaultProps: {
				disableFocusRipple: true, // Disable the focus ripple globally
			},
			styleOverrides: {
				root: {
					"&:focus-visible": {
						boxShadow: `0px 1px 10px ${theme.themeShadow}`,
					},
				},
			},
		},
		// Global Tab customizations
		MuiTab: {
			defaultProps: {
				disableFocusRipple: true, // Disable the focus ripple globally
			},
			styleOverrides: {
				root: {
					"&:focus-visible": {
						boxShadow: `0px 10px 20px ${theme.themeShadow}`, // Custom focus styles for Tab
					},
				},
			},
		},
	},
});

function App() {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Provider store={store}>
				<Router history={history}>
					<ThemeProvider theme={appFont}>
						<CustomRoutes />
					</ThemeProvider>
				</Router>
			</Provider>
		</LocalizationProvider>
	);
}
export default App;
